import styled from 'styled-components';

import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { spacing } from 'ui/theme';

const RawChartLoadingIcon = ({ height = 291, width = 291, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 291 291" fill="none" {...props}>
    <mask id="path-2-inside-1" fill="white">
      <path d="M24.6957 133.205C22.1772 157.078 26.7945 181.161 37.9636 202.41C49.1328 223.659 66.3522 241.118 87.4443 252.581C108.536 264.043 132.554 268.994 156.46 266.807C180.365 264.619 203.086 255.392 221.747 240.292C240.409 225.193 254.174 204.898 261.302 181.976C268.429 159.053 268.599 134.531 261.79 111.512C254.981 88.4926 241.499 68.0093 223.048 52.6522C204.597 37.2952 182.007 27.7542 158.134 25.2358L145.4 145.939L24.6957 133.205Z" />
    </mask>
    <path
      d="M24.6957 133.205C22.1772 157.078 26.7945 181.161 37.9636 202.41C49.1328 223.659 66.3522 241.118 87.4443 252.581C108.536 264.043 132.554 268.994 156.46 266.807C180.365 264.619 203.086 255.392 221.747 240.292C240.409 225.193 254.174 204.898 261.302 181.976C268.429 159.053 268.599 134.531 261.79 111.512C254.981 88.4926 241.499 68.0093 223.048 52.6522C204.597 37.2952 182.007 27.7542 158.134 25.2358L145.4 145.939L24.6957 133.205Z"
      fill="#F5F4F4"
      stroke="white"
      strokeWidth="2"
      mask="url(#path-2-inside-1)"
    />
    <mask id="path-3-inside-2" fill="white">
      <path d="M30.3586 107.246C20.3379 137.039 22.2664 169.558 35.7383 197.957C49.2101 226.357 73.1745 248.423 102.587 259.51C132 270.598 164.568 269.842 193.435 257.402C222.302 244.962 245.217 221.809 257.357 192.815L145.4 145.939L30.3586 107.246Z" />
    </mask>
    <path
      d="M30.3586 107.246C20.3379 137.039 22.2664 169.558 35.7383 197.957C49.2101 226.357 73.1745 248.423 102.587 259.51C132 270.598 164.568 269.842 193.435 257.402C222.302 244.962 245.217 221.809 257.357 192.815L145.4 145.939L30.3586 107.246Z"
      fill="#F5F4F4"
      stroke="white"
      strokeWidth="2"
      mask="url(#path-3-inside-2)"
    />
    <mask id="path-4-inside-3" fill="white">
      <path d="M24.566 155.107C26.9404 186.45 41.3821 215.65 64.8514 236.56C88.3206 257.47 118.987 268.46 150.396 267.217C181.804 265.973 211.506 252.593 233.248 229.893C254.991 207.192 267.079 176.942 266.967 145.51L145.594 145.939L24.566 155.107Z" />
    </mask>
    <path
      d="M24.566 155.107C26.9404 186.45 41.3821 215.65 64.8514 236.56C88.3206 257.47 118.987 268.46 150.396 267.217C181.804 265.973 211.506 252.593 233.248 229.893C254.991 207.192 267.079 176.942 266.967 145.51L145.594 145.939L24.566 155.107Z"
      fill="#F5F4F4"
      stroke="white"
      strokeWidth="2"
      mask="url(#path-4-inside-3)"
    />
    <mask id="path-5-inside-4" fill="white">
      <path d="M40.3701 206.769C55.4213 232.756 79.5722 252.24 108.154 261.455C136.737 270.671 167.721 268.963 195.117 256.662C222.513 244.361 244.376 222.341 256.48 194.857C268.584 167.374 270.069 136.379 260.648 107.864L145.4 145.939L40.3701 206.769Z" />
    </mask>
    <path
      d="M40.3701 206.769C55.4213 232.756 79.5722 252.24 108.154 261.455C136.737 270.671 167.721 268.963 195.117 256.662C222.513 244.361 244.376 222.341 256.48 194.857C268.584 167.374 270.069 136.379 260.648 107.864L145.4 145.939L40.3701 206.769Z"
      fill="#F5F4F4"
      stroke="white"
      strokeWidth="2"
      mask="url(#path-5-inside-4)"
    />
    <mask id="path-6-inside-5" fill="white">
      <path d="M33.1548 192.119C44.5812 219.891 65.8978 242.441 92.9842 255.41C120.071 268.379 151.003 270.846 179.803 262.334C208.602 253.822 233.224 234.936 248.908 209.326C264.591 183.716 270.224 153.201 264.716 123.679L145.4 145.939L33.1548 192.119Z" />
    </mask>
    <path
      d="M33.1548 192.119C44.5812 219.891 65.8978 242.441 92.9842 255.41C120.071 268.379 151.003 270.846 179.803 262.334C208.602 253.822 233.224 234.936 248.908 209.326C264.591 183.716 270.224 153.201 264.716 123.679L145.4 145.939L33.1548 192.119Z"
      fill="#E0DEDF"
      stroke="#FAFAFA"
      strokeWidth="2"
      mask="url(#path-6-inside-5)"
    />
    <ellipse cx="145.4" cy="145.939" rx="56.8943" ry="56.8935" fill="white" />
  </SvgIcon>
);

export const ChartLoadingIcon = styled(RawChartLoadingIcon)`
  margin-left: ${spacing.x12};
`;
